import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./client";

// Single factory so tests can build a fresh client per render.
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, err) => {
          // Never retry auth/permission errors. Retry transient ones up to twice.
          if (err instanceof ApiError && [400, 401, 403, 404, 409, 422].includes(err.status)) return false;
          return failureCount < 2;
        },
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}
